module.exports = __webpack_public_path__ + "static/media/17039368.f33ad44c.jpg";